export function LoginSkeleton() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <div className="flex items-center justify-center mb-6">
            {/* Logo Placeholder */}
            <div className="h-10 w-10 rounded-full bg-gray-300 animate-pulse"></div>
          </div>
          {/* Title Placeholder */}
          <div className="h-8 w-3/4 mx-auto bg-gray-300 rounded animate-pulse mb-3"></div>
          {/* Subtitle Placeholder */}
          <div className="h-4 w-1/2 mx-auto bg-gray-300 rounded animate-pulse"></div>
        </div>

        <div className="rounded-xl bg-white p-8 shadow-lg">
          <div className="space-y-6">
            {/* Email Input Placeholder */}
            <div>
              <div className="h-4 w-1/4 bg-gray-300 rounded animate-pulse mb-2"></div>
              <div className="h-10 w-full bg-gray-300 rounded animate-pulse"></div>
            </div>
            {/* Password Input Placeholder */}
            <div>
              <div className="h-4 w-1/4 bg-gray-300 rounded animate-pulse mb-2"></div>
              <div className="h-10 w-full bg-gray-300 rounded animate-pulse"></div>
            </div>
            {/* Button Placeholder */}
            <div className="h-10 w-full bg-gray-300 rounded animate-pulse mt-8"></div>
          </div>
        </div>

        <div className="mt-8 text-center">
          {/* Footer Text Placeholder */}
          <div className="h-3 w-1/3 mx-auto bg-gray-300 rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
}
